import React, { useState } from 'react';
import { IconClose } from '@one-snap/sparkles';
import { useTranslations } from 'next-intl';
import { isMobile, isIOS, isSafari, isAndroid } from 'react-device-detect';

export function SmartBanner() {
  const t = useTranslations('shared.smartBanner');

  const [isBannerVisible, setBannerVisible] = useState(() => {
    const isClosed = sessionStorage.getItem('isBannerClosed');
    return isClosed !== 'true';
  });

  const handleCloseBanner = () => {
    setBannerVisible(false);
    sessionStorage.setItem('isBannerClosed', 'true');
  };

  // Specific device/browser checks
  if (!isMobile || (isIOS && isSafari)) {
    return null;
  }

  // Banner visibility check
  if (!isBannerVisible) {
    return null;
  }

  let appLink, storeText;
  if (isAndroid) {
    appLink = t('androidLink');
    storeText = t('inGooglePlay');
  } else if (isIOS) {
    appLink = t('appStoreLink');
    storeText = 'inAppStore';
  }

  return (
    <div
      className="flex flex-row justify-between items-center bg-SnapWhite p-3 rounded-lg shadow-md mx-2 mt-2"
      style={{ maxWidth: 480 }}
    >
      <div className="flex items-center flex-1 min-w-0">
        <button
          aria-label={t('close')}
          onClick={handleCloseBanner}
          className="mr-3 flex-shrink-0"
        >
          <IconClose iconColor="" />
        </button>
        <div className="w-12 h-12 rounded-xl overflow-hidden flex-shrink-0 bg-gray-100 flex items-center justify-center">
          <img
            src="/assets/smart-banner-logo.svg"
            alt="Snap Finance App Icon"
            width={40}
            height={40}
            className="w-10 h-10 object-contain"
          />
        </div>
        <div className="ml-4 min-w-0">
          <p className="font-bold text-black text-base truncate">
            {t('title')}
          </p>
          <p className="text-xs text-SnapGrey400 truncate">
            {t('description')}
          </p>
          <p className="text-xs text-SnapGrey400 mt-1">
            <span className="font-semibold text-black">{t('get')}</span> -{' '}
            {storeText}
          </p>
        </div>
      </div>
      {appLink && (
        <a
          href={appLink}
          className="ml-4 px-4 py-2 bg-SnapBlue text-white rounded-lg font-semibold text-sm shadow hover:bg-blue-700 transition"
          style={{ whiteSpace: 'nowrap' }}
        >
          {t('view')}
        </a>
      )}
    </div>
  );
}
